/** Fixed catalog requirement names returned by the backend lookups API. */
export const EVENT_REQUIREMENT_TYPES = {
  FENCE: "FENCE",
  PULL_AND_ROPES: "PULL_AND_ROPES",
  PATROL_CAR: "PATROL_CAR",
  TRAFFIC_CONE: "TRAFFIC_CONE",
  LIGHT_STICK: "LIGHT_STICK",
  WATER_BARRIER: "WATER_BARRIER",
};

/** Display names as returned by the backend (English catalog labels). */
export const EVENT_REQUIREMENT_TYPE_NAMES = {
  [EVENT_REQUIREMENT_TYPES.FENCE]: "Fence",
  [EVENT_REQUIREMENT_TYPES.PULL_AND_ROPES]: "Pull & ropes",
  [EVENT_REQUIREMENT_TYPES.PATROL_CAR]: "Patrol car",
  [EVENT_REQUIREMENT_TYPES.TRAFFIC_CONE]: "Traffic cone",
  [EVENT_REQUIREMENT_TYPES.LIGHT_STICK]: "Light stick",
  [EVENT_REQUIREMENT_TYPES.WATER_BARRIER]: "Water barrier",
};

export const EVENT_REQUIREMENT_VISUALS = {
  [EVENT_REQUIREMENT_TYPES.FENCE]: {
    iconName: "eventRequirementFence",
    backgroundColor: "var(--color-background-subtle)",
    iconColor: "var(--color-primary-default)",
  },
  [EVENT_REQUIREMENT_TYPES.PULL_AND_ROPES]: {
    iconName: "eventRequirementPullRopes",
    backgroundColor: "var(--color-background-muted)",
    iconColor: "var(--color-primary-default)",
  },
  [EVENT_REQUIREMENT_TYPES.PATROL_CAR]: {
    iconName: "eventRequirementPatrolCar",
    backgroundColor: "var(--color-success-subtle)",
    iconColor: "var(--color-success-default)",
  },
  [EVENT_REQUIREMENT_TYPES.TRAFFIC_CONE]: {
    iconName: "eventRequirementTrafficCone",
    backgroundColor: "var(--color-warning-subtle)",
    iconColor: "var(--color-warning-default)",
  },
  [EVENT_REQUIREMENT_TYPES.LIGHT_STICK]: {
    iconName: "eventRequirementLightStick",
    backgroundColor: "var(--color-destructive-subtle)",
    iconColor: "var(--color-destructive-default)",
  },
  [EVENT_REQUIREMENT_TYPES.WATER_BARRIER]: {
    iconName: "eventRequirementWaterBarrier",
    backgroundColor: "var(--color-background-subtle)",
    iconColor: "var(--color-cyan-default)",
  },
};

const normalizeRequirementName = (name) =>
  String(name ?? "")
    .trim()
    .toLowerCase()
    .replace(/\s+/g, " ");

const REQUIREMENT_NAME_TO_TYPE = Object.entries(
  EVENT_REQUIREMENT_TYPE_NAMES,
).reduce((acc, [typeKey, label]) => {
  acc[normalizeRequirementName(label)] = typeKey;
  return acc;
}, {});

export const getEventRequirementTypeKey = (name) =>
  REQUIREMENT_NAME_TO_TYPE[normalizeRequirementName(name)] ?? null;

export const getEventRequirementVisual = (name) => {
  const typeKey = getEventRequirementTypeKey(name);
  return typeKey ? EVENT_REQUIREMENT_VISUALS[typeKey] : null;
};

export const isKnownEventRequirementName = (name) =>
  Boolean(getEventRequirementTypeKey(name));
